import { useEffect } from 'react';
import { useSubscription } from '../context/SuscriptionContext';
import Modal from '../components/payment/modal';
import CancelMessage from '../components/payment/CancelMessage';
import Button from '../components/payment/Button';
import { ButtonFluxi } from '../components/common/Buttons/ButtonFluxi/ButtonFluxi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { dictionary } from '../utils/dictionary';

const CancelPage = () => {
  const { language } = useAuth();
  const navigate = useNavigate();

  const screenWidth = window.innerWidth;
  const navigateTo = screenWidth < 768 ? "/settings" : "/plans";
  
  return (
    <Modal onClose={() => { /* handle close */ }} navigationPath={navigateTo}>
      <CancelMessage />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <ButtonFluxi text={dictionary["try-again"][language]} onClick={() => {
          navigate(navigateTo);
        }} />
      </div>
    </Modal>
  );
};
export default CancelPage;